import { EstateImprovement } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import {
  ElectricIcon,
  FridgeIcon,
  IntercomIcon,
  LockIcon,
  SafeIcon,
  ShieldCheckeredIcon,
  ShieldLockIcon,
  WorkbenchIcon,
} from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";

type Props = {
  type: EstateImprovement;
  currentLevelValue: number;
  levels: {
    value: number;
    amount: number;
    materials: number;
  }[];
};
const iconImprove: Record<EstateImprovement, FC<BaseIconProps>> = {
  [EstateImprovement.Workbench]: WorkbenchIcon,
  [EstateImprovement.Wardrobe]: undefined,
  [EstateImprovement.Safe]: SafeIcon,
  [EstateImprovement.Intercom]: IntercomIcon,
  [EstateImprovement.ExtraFridge]: FridgeIcon,
  [EstateImprovement.Security]: ShieldCheckeredIcon,
  [EstateImprovement.eLock]: ShieldLockIcon,
  [EstateImprovement.eCharger]: ElectricIcon,
};

export default function EstateImprovementLevels({ type, currentLevelValue, levels }: Props) {
  const { t } = useTranslation("estate");

  return (
    <div>
      <p className="text-12 font-bold uppercase">{t("estate.improvements.levels")}:</p>
      <div className="flex items-center gap-2.5 py-3.5 px-1 border-b border-b-[#191919]">
        {iconImprove?.[type]({ size: 16 })}
        <p className="min-w-[4.75rem] text-16 font-medium">{t("estate.improvements.level")} 1</p>
        <p className="ml-auto text-16 font-bold text-accent-solid">0 ₽</p>
      </div>
      {levels.map((level) => (
        <div
          key={level.value}
          className="flex items-center gap-2.5 py-3.5 px-1 border-b border-b-[#191919]"
        >
          {currentLevelValue >= level.value ? (
            iconImprove?.[type]({ size: 16 })
          ) : (
            <LockIcon size={16} />
          )}
          <p
            className={`min-w-[4.75rem] text-16 font-medium ${currentLevelValue >= level.value ? "" : "text-white/50"}`}
          >
            {t("estate.improvements.level")} {level.value + 1}
          </p>
          <p className="ml-auto text-16 font-bold text-accent-solid">
            {formatPrice(level.amount)} ₽
          </p>
        </div>
      ))}
    </div>
  );
}
